import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20background%2C%20colorful%20manga%20panels%20collage%2C%20vibrant%20warm%20coral%20and%20gold%20gradient%2C%20abstract%20comic%20book%20elements%2C%20soft%20geometric%20patterns%2C%20artistic%20composition%2C%20bright%20but%20soft%20lighting%2C%20modern%20webtoon%20aesthetic&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="韩漫网站 - 免费韩漫在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="漫画免费韩漫 - 下拉式韩漫在线 - 阅读漫画大全"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight"
            style={{ fontFamily: 'var(--font-heading)' }}>
            漫画免费韩漫
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            专业提供海量<strong>漫画免费韩漫</strong>，支持<strong>下拉式韩漫在线</strong>阅读，涵盖丰富的<strong>阅读漫画大全</strong>资源，随时随地畅享高清流畅阅读体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/love"
              className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer hover:scale-105 transform"
            >
              立即开始阅读
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-medium hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-400">10,000+</p>
              <p className="text-xs text-background-300 mt-1">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-400">50万+</p>
              <p className="text-xs text-background-300 mt-1">每日读者</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-accent-400">8大</p>
              <p className="text-xs text-background-300 mt-1">分类频道</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}